export const isMobile = () => window.innerWidth <= 767;
export const isTablet = () => window.innerWidth >= 768 && window.innerWidth < 1024;
export const isDesktop = () => window.innerWidth >= 1024 && window.innerWidth < 1536;
export const isDesktopLarge = () => window.innerWidth >= 1536;

export const isTabletOrSmaller = () => window.innerWidth <= 1023;
export const isTabletOrLarger = () => window.innerWidth >= 768;
export const isDesktopSmall = () => window.innerWidth >= 1024;
export const isDesktopMedium = () => window.innerWidth >= 1280;
export const isDesktopOrLarger = () => window.innerWidth >= 1024;
export const isSize = (size: number) => window.innerWidth >= size;
export const isMaxSize = (size: number) => window.innerWidth <= size;

export function getValueForScreenSize(defaultValue, valuesMap) {
  if (isMobile()) {
    return valuesMap?.mobile ? valuesMap?.mobile : defaultValue;
  } else if (isTablet()) {
    return valuesMap?.tablet ? valuesMap?.tablet : defaultValue;
  } else if (isDesktop()) {
    return valuesMap?.desktop ? valuesMap?.desktop : defaultValue;
  } else if (isDesktopLarge()) {
    return valuesMap?.desktopL ? valuesMap?.desktopL : defaultValue;
  } else {
    return valuesMap?.desktopL ? valuesMap?.desktopL : defaultValue;
  }
}
